/* Triple Whale: ALL product media-panel initial video play-button clicks.
 * Install as assets/product-video-tracking.js in the active theme,
 * then load once on product pages with:
 * {% if request.page_type == 'product' %}
 * <script src="{{ 'product-video-tracking.js' | asset_url }}" defer></script>
 * {% endif %}
 * Event configuration productVideoPlay is saved in Triple Whale.
 * Counts trusted initial poster/play-button clicks, and video thumbnail clicks that
 * start a not-yet-loaded player in slider galleries; not autoplay/loops/completions.
 *
 * Enterprise 2.3.0 note: product data is read from the section's
 * script[data-tw-product-json] (rendered in sections/main-product.liquid), because
 * the 2.3.0 variant picker JSON only holds the current variant. The 1.6.1
 * variant-picker JSON ({ product: ... }) is kept as a fallback.
 */
(function () {
  'use strict';
  if (window.__twProductVideoTracking) return;
  window.__twProductVideoTracking = true;
  // Product pages are reached as /products/<handle> and, from collection grids, as
  // /collections/<collection>/products/<handle> (optionally behind a locale prefix).
  if (!/^(?:\/collections\/[^/]+)?\/products\/[^/]+\/?$/.test(window.location.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/(?:collections|products)\/)/i, ''))) return;

  document.addEventListener('click', function (event) {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    var deferred = null;
    var button = event.target.closest('deferred-media button.js-load-media');
    if (button && button.closest('#product-media')) {
      deferred = button.closest('deferred-media');
    } else {
      // Slider galleries: clicking a video's thumbnail makes the theme load the player
      // with autoplay (MediaGallery.playActiveMedia), skipping the poster button. Count
      // that as an initial play only while the player is not loaded yet, so re-clicking
      // the thumbnail of an already started video is not counted again.
      var thumb = event.target.closest('#product-media .media-thumbs__item[data-media-id]');
      if (!thumb) return;
      var gallery = thumb.closest('#product-media');
      var item = gallery.querySelector('.media-viewer__item[data-media-id="' + thumb.getAttribute('data-media-id') + '"]');
      deferred = item && item.querySelector('deferred-media');
      if (!deferred || deferred.hasAttribute('loaded')) return;
      button = deferred.querySelector('button.js-load-media');
      if (!button) return;
    }
    var template = deferred.querySelector('template');
    var mediaRoot = template ? template.content : deferred;
    var video = mediaRoot.querySelector('video');
    var iframe = mediaRoot.querySelector('iframe');
    var source = video && video.querySelector('source');
    var rawUrl = video ? (video.getAttribute('src') || (source && source.getAttribute('src'))) : (iframe && iframe.getAttribute('src'));
    if (!rawUrl) return;
    var url;
    try { url = new URL(rawUrl, window.location.href); } catch (error) { return; }
    var provider = video ? 'html5' : (/^(www\.)?(youtube\.com|youtube-nocookie\.com)$/.test(url.hostname) ? 'youtube' : (/^(www\.|player\.)?vimeo\.com$/.test(url.hostname) ? 'vimeo' : ''));
    if (!provider) return;
    var poster = button.querySelector('img');
    var label = (video && video.getAttribute('aria-label')) || (poster && poster.getAttribute('alt')) || (iframe && iframe.getAttribute('title')) || '';

    var section = button.closest('.js-product') || document.querySelector('.js-product');
    var data = section && section.querySelector('script[data-tw-product-json]');
    if (!data) {
      var picker = section && section.querySelector('variant-picker');
      data = picker && picker.querySelector('script[type="application/json"]');
    }
    var product;
    try { product = data && JSON.parse(data.textContent).product; } catch (error) { return; }
    if (!product || !product.id || !product.handle) return;
    if (typeof window.TriplePixel !== 'function') return;
    var variantInput = section.querySelector('.js-product-form-main input[name="id"]');
    var variantId = variantInput ? variantInput.value : '';
    var variant = (product.variants || []).find(function (item) { return String(item.id) === variantId; });
    // Triple Pixel rejects any property of 100+ characters and then stops executing
    // for the page, so every value is capped at 99. Long HTML5 CDN URLs hit this; the
    // first 99 characters still include the video's unique hash, and mediaId is unaffected.
    var clip = function (value) { return String(value == null ? '' : value).slice(0, 99); };
    try {
      window.TriplePixel('custom', 'productVideoPlay', {
        productId: clip(product.id),
        productHandle: clip(product.handle),
        productTitle: clip(product.title),
        variantId: clip(variantId),
        variantTitle: clip(variant ? variant.title : ''),
        videoLabel: clip(label.trim()),
        mediaId: clip(provider === 'html5' ? (deferred.getAttribute('data-media-id') || url.pathname) : (url.pathname.split('/').filter(Boolean).pop() || '')),
        videoUrl: clip(url.origin + url.pathname),
        pageUrl: clip(window.location.origin + window.location.pathname),
        videoProvider: clip(provider)
      });
    } catch (error) {
      // Analytics must never interrupt the theme's existing playback handler.
    }
  }, true);
}());
